import { useMemo } from "react";
import { useAppSelector } from "../../store/index.ts";

export default function useMinPriceByMode() {
  const chatActiveMode = useAppSelector((state) => state.chat.chatActiveMode);
  const settingInfo = useAppSelector((state) => state.chat.settingInfo?.[chatActiveMode]) || {};
  const { price, time } = settingInfo.billing || {};

  const priceMin = price?.value || 0;
  const timeMin = (time?.value || 0) / 60;

  const minPriceForMin = useMemo(() => priceMin * timeMin, [priceMin, timeMin]);

  return minPriceForMin;
}
